// extracted by mini-css-extract-plugin
export default {"container":"Clicker_container__7IWRe","game":"Clicker_game__riUBR","piece":"Clicker_piece__oxaSy"};